// CANONICAL COPY (GH #7115). src/constants/obligations/obl-special-interest-groups.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-special-interest-groups',
  title: 'Maintain contact with special interest groups',
  description:
    'Confirm that the organisation maintains appropriate contacts with special interest groups, security forums, professional associations and information-sharing communities relevant to its sector. Membership is used to stay current with the evolving threat landscape, vulnerability disclosures and emerging best practices, and to exchange information with peers. Review membership, liaison responsibilities and a record of information received and disseminated internally.',
  category: 'governance',
  scfIds: ['SCF-GOV-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Special interest group contact list / procedure is published',
    },
    { type: 'document-within-sla', description: 'Contact list review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
